import { Card } from 'antd'
import { CardProps } from 'antd/lib'

import { useStyles } from './styles'

export const CardWithTitle = (props: CardProps) => {
  const { styles } = useStyles()

  return (
    <Card className={styles.card} {...props}>
      {props.children}
    </Card>
  )
}
